import { type } from "../types/types";

export const set_user = (user) => (dispatch) => {
  dispatch({
    type: type.SET_USER,
    user,
  });
};
